export type ConcretePreset = 'hero' | 'aged' | 'wet' | 'dusty' | 'aggregate';

export type ConcreteShowcaseId =
  | 'hero'
  | 'gallery'
  | 'lighting'
  | 'scale'
  | 'mapping'
  | 'impact'
  | 'blast'
  | 'settled'
  | 'quality'
  | 'stress';

export interface ConcreteShowcaseItem {
  id: ConcreteShowcaseId;
  label: string;
  proof: string;
}

export const CONCRETE_SHOWCASES: ConcreteShowcaseItem[] = [
  { id: 'hero', label: 'Hero slab', proof: 'Full-wall scale, color, roughness, and micro-normal detail' },
  { id: 'gallery', label: 'Material gallery', proof: 'One concrete system, five surface states' },
  { id: 'lighting', label: 'Lighting gallery', proof: 'Surface response survives neutral and dramatic light' },
  { id: 'scale', label: 'Scale test', proof: 'Real-world texture size holds from context to close-up' },
  { id: 'mapping', label: 'Moving chunk', proof: 'Stable wall-space detail stays attached during motion' },
  { id: 'impact', label: 'Single impact', proof: 'Fresh fracture surface separates from weathered exterior' },
  { id: 'blast', label: 'Full blast', proof: 'Interior aggregate reads across many fragments' },
  { id: 'settled', label: 'Settled rubble', proof: 'Material identity survives the final pile' },
  { id: 'quality', label: 'Quality tiers', proof: 'High, medium, and low modes remain readable' },
  { id: 'stress', label: 'Stress test', proof: 'Exercises the live chunk cap beside render cost' },
];

export const CONCRETE_PRESETS: Array<{ id: ConcretePreset; label: string; description: string }> = [
  {
    id: 'hero',
    label: 'Hero',
    description: 'Clean cast concrete with restrained macro variation',
  },
  {
    id: 'aged',
    label: 'Aged',
    description: 'Broad discoloration plus vertical runoff staining and local roughness',
  },
  {
    id: 'wet',
    label: 'Wet',
    description: 'Irregular wet patches/streaks that darken albedo and lower roughness only where wet',
  },
  {
    id: 'dusty',
    label: 'Dusty',
    description: 'Pale dust concentrated by stable masks and orientation; higher roughness, softer normals',
  },
  {
    id: 'aggregate',
    label: 'Aggregate',
    description: 'Exposed mineral aggregate in patches (scanned: Concrete025 secondary layer)',
  },
];

/** One-line proof copy for the active surface state (same camera/light comparison). */
export const CONCRETE_STATE_PROOF: Record<ConcretePreset, string> = {
  hero: 'Hero: clean cast finish — subtle cement grain, sparse pores, restrained macro tint.',
  aged: 'Aged: spatial stains + vertical runoff, not a flat recolor; roughness rises in stained areas.',
  wet: 'Wet: irregular wet patches darken and gloss locally; dry regions stay matte.',
  dusty: 'Dusty: pale powder in broad masks (visible on vertical walls); normals soften under dust.',
  aggregate: 'Aggregate: mineral inclusions exposed in patches; scanned mode layers Concrete025.',
};

export const CONCRETE_QUALITY_OPTIONS = ['high', 'medium', 'low'] as const;
